module.exports = __webpack_public_path__ + "img/pc_lion_bg.101e6ad.webp";